// Poster mode is opt-in; an absent flag preserves live pages and P99 results.
export const isPosterEnabled = (value) => String(value ?? "").trim().toLowerCase() === "true";

export const Env = {
    REACT_APP_NODE_ENV: window.REACT_APP_NODE_ENV || process.env.REACT_APP_NODE_ENV,
    REACT_APP_API_BASE_URL: window.REACT_APP_API_BASE_URL || process.env.REACT_APP_API_BASE_URL,
    REACT_APP_WEB_SOCKET: window.REACT_APP_WEB_SOCKET || process.env.REACT_APP_WEB_SOCKET,
    REACT_APP_IS_POSTER: isPosterEnabled(window.REACT_APP_IS_POSTER ?? process.env.REACT_APP_IS_POSTER),
};

